var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-row",
    [
      _c(
        "w-col",
        [
          _c(
            "w-card",
            [
              _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("text-settings")))]),
              _c(
                "w-card-content",
                [
                  _c(
                    "w-row",
                    [
                      _c(
                        "w-col",
                        { attrs: { xs: "12" } },
                        [
                          _c("app-custom-language-select", {
                            model: {
                              value: _vm.selectedLanguage,
                              callback: function ($$v) {
                                _vm.selectedLanguage = $$v
                              },
                              expression: "selectedLanguage",
                            },
                          }),
                        ],
                        1
                      ),
                      false
                        ? _c(
                            "w-col",
                            { attrs: { xs: "12" } },
                            [
                              _c("w-input", {
                                attrs: { label: _vm.$ct("page"), fancy: "" },
                                model: {
                                  value:
                                    _vm.settings.PageNumber.Translations[
                                      _vm.selectedLanguage
                                    ],
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.settings.PageNumber.Translations,
                                      _vm.selectedLanguage,
                                      $$v
                                    )
                                  },
                                  expression:
                                    "settings.PageNumber.Translations[selectedLanguage]",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "w-col",
                        { attrs: { xs: "12" } },
                        [
                          _c("w-input", {
                            attrs: { label: _vm.$ct("duplicate"), fancy: "" },
                            model: {
                              value:
                                _vm.settings.Duplicate.Translations[
                                  _vm.selectedLanguage
                                ],
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.settings.Duplicate.Translations,
                                  _vm.selectedLanguage,
                                  $$v
                                )
                              },
                              expression:
                                "settings.Duplicate.Translations[selectedLanguage]",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }